import styled from 'styled-components'

//
// Form Styling
//
interface StyledInputProps {
  errorBorder?: string
}

export const StyledInput = styled.input<StyledInputProps>`
  color: #111;
  border: 1px solid #777;
  border-color: ${(props) => (props.errorBorder ? '#EE3333' : '#777')};
  border-radius: 3px;
  background-color: #eee;
  padding: 5px;

  :focus {
    border: 1px solid #777;
    background-color: #eee;
    outline: 1px solid #eee;
  }

  :hover {
    border-color: #666;
  }
`

export const StyledButton = styled.button`
  &&& {
    background-color: #222222;
    border: 2px solid #03abe533;
    border-radius: 4px;
    box-sizing: border-box;
    color: #03abe5;
    cursor: pointer;
    text-align: center;
    user-select: none;
    -webkit-user-select: none;
    vertical-align: middle;
    white-space: nowrap;
    padding-top: 7px;
    padding-bottom: 6px;
    font-family: monospace;
    font-size: 1rem;
  }

  &&&:hover:enabled {
    background-color: #121212;
    color: '#fff';
    border: 2px solid #03abe533;
  }

  &&&:active:enabled {
    background-color: #121212;
    color: '#fff';
    border: 2px solid #03abe533;
  }
`
